//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import APIloading from '~/components/common/APILoading.vue'
import APIFailed from '~/components/common/APIFailed.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    APIloading,
    APIFailed
  },
  data () {
    return {
      category: this.$i18n.t('careers.block1.field1'),
      catList: this.categories,
      careers: [],
      fetched: false,
      fetchError: false
    }
  },
  async fetch () {
    // try {
    //   const careers = await fetch('https://api.pagsmile.com/index.php?r=api%2Fjob')
    //     .then(res => res.json())
    //     .catch(function (e) {
    //       console.log(e)
    //     })
    //   if (careers.length) {
    //     const openCareers = careers.filter(carr => (Number(carr.status) === 1))
    //     if (openCareers.length) {
    //       this.careers = openCareers
    //       return
    //     }
    //   }
    //   this.fetched = true
    //   this.careers = []
    // } catch (err) {
    //   console.log('err', err)
    //   this.careers = []
    //   this.fetched = true
    //   this.fetchError = true
    // }
  },
  head () {
    return {
      title: this.$t('footer.about.careers').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  // fetchOnServer: false,
  computed: {
    categories () {
      if (this.careers && this.careers.length) {
        const careerList = [
          {
            id: 'none',
            specialty: this.$i18n.t('careers.block1.field1')
          },
          ...this.careers]
        return Object.values(careerList.reduce((acc, cur) => Object.assign(acc, { [cur.specialty]: cur }), {}))
      } else {
        return []
      }
    },
    sortedItems () {
      if (this.categories.length) {
        const x = {}
        let categories
        if (this.category === this.$i18n.t('careers.block1.field1')) {
          categories = this.categories.filter(cat => cat.id !== 'none')
        } else {
          categories = this.categories.filter(cat => cat.specialty === this.category)
        }
        categories.forEach((item, index) => {
          /* console.log('category', item.category)
          console.log('filter', this.careers.filter(position => position.category === item.category)) */
          x[index] = { category: item.specialty, items: this.careers.filter(position => position.specialty === item.specialty) }
          return x
        })
        /* console.log('sItems', x) */
        return x
      } else {
        return []
      }
    }
  },
  mounted () {
    this.clientFetch()
  },
  methods: {
    clientFetch () {
      this.$fetch()
    }
  }
}
